import FlatScene from "../../components/FlatScene"
export default function Scroll(){
    return(
        <FlatScene />
    );
}